var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h2',{staticClass:"text-center"},[_vm._v("Autoryzacja w toku...")]),_c('loader',{attrs:{"active":_vm.loading}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }